import 'whatwg-fetch';
import Promise from 'bluebird';
import qs from 'qs';
import _ from 'underscore';
const DEFAULT_ERROR_MESSAGE = 'Something went wrong on our servers. Please contact support if this issue persists.';

// Helpers
// fetch API does not reject on HTTP error statuses by default, we have to
// handle this ourselves (https://github.com/github/fetch#handling-http-error-statuses)
function checkStatus(response, format) {
  return new Promise((resolve, reject) => {
    if (response.status >= 200 && response.status < 400) {
      let getResults;

      switch (format) {
        case 'json':
          getResults = response.json();
          break;
        default:
          getResults = Promise.resolve();
          break;
      }

      getResults.then(results => resolve({ response, results, headers: response.headers }));
    } else {
      response.json().then(json => reject(json));
    }
  });
}

function getError(err, requestUrl) {
  if (typeof err === 'string') {
    return new Error(err);
  }

  let errorMessage;
  const hasErrors = err && err.errors;
  const errors = hasErrors ? err.errors : null;

  if (errors) {
    errorMessage = _.map(errors, (_err) => {
      const attr = _err.attribute ? `${_err.attribute}:` : '';
      const message = _err.message;

      return `${attr} ${message}`;
    }).join('; ');
  } else {
    errorMessage = DEFAULT_ERROR_MESSAGE;
  }

  const error = new Error(errorMessage);
  /* eslint-disable */
  console.info('Failed request: ', requestUrl);
  /* eslint-enable */
  return error;
}

function getHeaders(accessToken, customHeaders) {
  const headers = new Headers();

  if (accessToken) {
    headers.set('Authorization', `Bearer ${accessToken}`);
  }

  headers.set('Accept', 'application/json');
  Object.keys(customHeaders).forEach((key) => headers.set(key, customHeaders[ key ]));

  return headers;
}

const paramify = (paramObject) => qs.stringify(paramObject, { arrayFormat: 'repeat', delimiter: '&' });

export function get(params) {
  const { accessToken, format = 'json', headers = {}, params: requestParams, url } = params;
  const urlWithParams = `${url}${requestParams ? `?${paramify(requestParams)}` : ''}`;

  return new Promise((resolve, reject) => {
    fetch(urlWithParams, { method: 'GET', headers: getHeaders(accessToken, headers) })
      .then((res) => checkStatus(res, format))
      .then((res) => resolve(res))
      .catch((err) => reject(getError(err, `GET ${JSON.stringify(params)}`)));
  });
}

/**
 * This helper method does a POST with the fetch api
 * @param accessToken
 * @param params
 * @param responseType
 * @param headers
 * @param url
 * returns {Promise}
 */
export function post({
  accessToken,
  responseType = 'json',
  headers = { 'Content-Type': 'application/json' },
  params,
  url
}) {
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
      headers: getHeaders(accessToken, headers)
    })
      .then((res) => checkStatus(res, responseType))
      .then((res) => resolve(res))
      .catch((err) => reject(getError(err, `POST ${url}${JSON.stringify(params)}`)));
  });
}

/**
 * This helper method does a PUT with the fetch api
 * @param accessToken
 * @param params
 * @param headers
 * @param url
 * returns {Promise}
 */
// export function put({ accessToken, headers={}, params, url }) {
//   return new Promise((resolve, reject) => {
//     fetch(url, {
//       method: 'PUT',
//       body: JSON.stringify(params),
//       headers: getHeaders(accessToken, headers)
//     })
//       .then(checkStatus)
//       .then(resolve)
//       .catch((err) => reject(getError(err)));
//   });
// }

/**
 * This helper method does a DELETE with the fetch api, but is named 'destroy' because delete is a reserved word
 * @param accessToken
 * @param params
 * @param headers
 * @param url
 * returns {Promise}
 */
// export function destroy({ accessToken, headers={}, params, url }) {
//   return new Promise((resolve, reject) => {
//     fetch(url, {
//       method: 'DELETE',
//       body: JSON.stringify(params),
//       headers: getHeaders(accessToken, headers)
//     })
//       .then(checkStatus)
//       .then(resolve)
//       .catch((err) => reject(getError(err)));
//   });
// }


// WEBPACK FOOTER //
// ./src/js/fetch.js